import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class EventosSemanalesView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            navieras: [],
            barcos: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {semana_Id: semana_Id, descripcion: "" };
        }
        this.state.modelValidation = {
            semana_Id: this.state.model.semana_Id != 0,
            descripcion: this.state.model.descripcion != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000);
        this.populateData = this.populateData.bind(this);
    }

    async handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, async () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/eventosSemanales/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="descripcion">
                                        <FormattedMessage id='Descripcion' />
                                    </Label>
                                    <FormattedMessage id='Descripcion'>
                                        {(placeholder) =>
                                            <Input
                                                id="descripcion"
                                                name="descripcion"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.descripcion}
                                                valid={this.getValidationValue(this.state.modelValidation.descripcion)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.descripcion)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.descripcion == '' ? <FormattedMessage id='Este campo es requerido' /> : ''}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            {/*<Col></Col>*/}
                        </Row>
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {

    }

    
}